/**
 * @description
 * @author librajt
 * @date
 */

import React , { Component  } from 'react';
import './userLevelBadge.scss';

import { displayUserLevel , getUserLevelColorScheme} from '../../../utils/userAchievementUtil';

export type TUserLevelSize = 'M' | 'L' | undefined;


interface IUserLevelBadgeProps {
    userLevelSize: TUserLevelSize;
    userLevelInfo: number;
}

export default class UserLevelBadge extends Component<IUserLevelBadgeProps, {}> {
    public render() {
        const { userLevelInfo, userLevelSize } = this.props;
        const lvColorScheme = getUserLevelColorScheme(userLevelInfo, true);

        const size = userLevelSize ? ' size-' + userLevelSize : '';

        return (
            <div className={'user-level-badge' + size} style={{ backgroundColor: lvColorScheme.primary }}>
                <div className="user-level" style={{ color: lvColorScheme.secondary }}>
                    {displayUserLevel(userLevelInfo)}
                </div>
            </div>
        );
    }
}
